var _style, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBxsFileDoc(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "-587 439 24 24",
    style: {
      enableBackground: "new -587 439 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#7C7B7B;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-574.8,453.6c-0.6,0-1,0.6-1,1.4c0,0.8,0.4,1.4,1,1.4c0.6,0,1-0.6,1-1.4C-573.8,454.2-574.2,453.6-574.8,453.6 z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-573,441h-8c-1.1,0-2,0.9-2,2v16c0,1.1,0.9,2,2,2h12c1.1,0,2-0.9,2-2v-12L-573,441z M-577.8,456.5 c-0.4,0.4-1.1,0.5-1.9,0.5c-0.5,0-0.8,0-1-0.1v-4c0.4-0.1,0.8-0.1,1.2-0.1c0.8,0,1.3,0.1,1.7,0.4c0.4,0.3,0.7,0.8,0.7,1.5 C-577.2,455.6-577.5,456.1-577.8,456.5z M-574.9,457c-1.2,0-1.9-0.9-1.9-2.1c0-1.2,0.8-2.1,2-2.1c1.2,0,1.9,0.9,1.9,2 C-572.9,456.2-573.7,457-574.9,457z M-570.2,456.2c0.3,0,0.6-0.1,0.8-0.1l0.1,0.7c-0.2,0.1-0.5,0.2-1,0.2c-1.4,0-2.1-0.9-2.1-2 c0-1.4,1-2.1,2.2-2.1c0.5,0,0.8,0.1,1,0.2l-0.2,0.7c-0.2-0.1-0.5-0.2-0.8-0.1c-0.7,0-1.3,0.4-1.3,1.3 C-571.5,455.7-571,456.2-570.2,456.2z M-573,448h-1v-5l5,5H-573z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-579.4,453.6c-0.2,0-0.3,0-0.4,0v2.6c0.1,0,0.2,0,0.3,0c0.8,0,1.4-0.4,1.4-1.4 C-578.1,454-578.6,453.6-579.4,453.6z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBxsFileDoc);
export default __webpack_public_path__ + "static/media/bxs-file-doc.53d41ffc2d9fa6f08d1233ab80927d63.svg";
export { ForwardRef as ReactComponent };